const UPDATE_CL_EVENT = 'clEvents/UPDATE_CL_EVENT';
const SET_CL_EVENTS = 'clEvents/SET_CL_EVENTS';

export default {
  UPDATE_CL_EVENT,
  SET_CL_EVENTS,
};



// WEBPACK FOOTER //
// ./src/app/cl-events/store/mutation-types.js